/* unplugin-vue-components disabled */import script from "./TrialFundWaitingTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialFundWaitingTitle.vue?vue&type=script&setup=true&lang=js"

import "./TrialFundWaitingTitle.vue?vue&type=style&index=0&id=5f8d8cab&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8d8cab"]])

export default __exports__